import { Tool } from "@/types/tools";
import aggregateBlaze from "./aggregate/blaze";
import riskBandsBatch from "./risk-bands/batch";
import riskBandsSingle from "./risk-bands/single";

/**
 * All tools, excluding ones which are in development.
 */
export const allTools: Tool[] = [riskBandsSingle, riskBandsBatch, aggregateBlaze];